import { ThemeProperties } from '../../core';

export interface BadgeTextTheme {
	basePadding: string;
	baseBorderRadius: string;
	baseAdjustTextPadding: string;
	interactiveBackground: string;
	interactiveTextColor: string;
	brandDarkBackground: string;
	brandDarkTextColor: string;
	brandLightBackground: string;
	brandLightTextColor: string;
	neutralDarkBackground: string;
	neutralDarkTextColor: string;
	neutralLightBackground: string;
	neutralLightTextColor: string;
	successBackground: string;
	successTextColor: string;
	infoBackground: string;
	infoTextColor: string;
	warningBackground: string;
	warningTextColor: string;
	dangerBackground: string;
	dangerTextColor: string;
	smallText: string;
	smallHeight: string;
	mediumText: string;
	mediumHeight: string;
}

export const theme = new ThemeProperties('badgeText');
